/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Barcode: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M20 2H15V22H20V2Z' fill='currentColor' />
    <path d='M9 2H4V22H9V2Z' fill='currentColor' />
    <path d='M13 2H11V22H13V2Z' fill='currentColor' />
    <path d='M2 2H0V22H2V2Z' fill='currentColor' />
    <path d='M24 2H22V22H24V2Z' fill='currentColor' />
  </React.Fragment>
)
